import React, { useState } from "react";
import { Wrap } from "./style";
import img from "../../../../assets/imgs/img.png";
import { Pagination, Popconfirm, message } from "antd";
import { useHousesContext } from "../../../../context/Houses";
import { useAxios } from "../../../../hooks/useAxios";
import { useMutation, useQuery } from "react-query";
import Edit from "./Edit";
import NoData from "../../../Generic/NoData";
export default function MyPropComponent() {
  const [{ size, page, meTotal, meHousesList }, dispatch] = useHousesContext();
  const handlePaginationChange = (n) => {
    dispatch({ type: "changePage", payload: n });
  };

  const { request } = useAxios();
  const deleteMeHouse = useMutation((id) => {
    return request({ url: `/v1/houses/${id}`, method: "DELETE" });
  });
  useQuery(
    ["fetchHouseMe", page, size],
    () =>
      request({
        url: `/v1/houses/me?page=${page - 1}&size=${size}`,
      }),
    {
      onSuccess: (res) => {
        console.log(res, "res");

        res?.data?.success &&
          dispatch({
            type: "setMeHousesList",
            payload: res?.data?.dataList[0],
          });
        dispatch({
          type: "setSize",
          payload: 3,
        });
        dispatch({
          type: "setMeTotal",
          payload: res?.data?.map?.total_elements,
        });
      },
    }
  );
  function confirm(e) {
    deleteMeHouse.mutate(e);
    message.success("House Successfully deleted");
    window.location.reload();
  }

  function cancel() {
    message.error("Click on No");
  }
  const [visible, setVisible] = useState(false);
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  return (
    <Wrap>
      <Wrap.Title>My Properties</Wrap.Title>
      <Wrap.Backin>Ready to jump back in?</Wrap.Backin>
      <Wrap.Body>
        <Wrap.Label>
          <Wrap.Wrap>
            <span>Order By: </span>
            <Wrap.Order>
              <option> New to Old</option>
              <option value="">Value</option>
              <option value="">Value</option>
              <option value="">Value</option>
              <option value="">Value</option>
            </Wrap.Order>
          </Wrap.Wrap>
          <Wrap.Wrap>
            <span>Filter By Status: </span>
            <Wrap.Filter>
              <option>All</option>
              <option value="">Value</option>
              <option value="">Value</option>
              <option value="">Value</option>
              <option value="">Value</option>
            </Wrap.Filter>
          </Wrap.Wrap>

          <Wrap.Search placeholder="Saerch a Listing" />
        </Wrap.Label>
        <Wrap.Table>
          <Wrap.Thead>
            <Wrap.Tr>
              <Wrap.Td className="listing-title">Listing Title</Wrap.Td>
              <Wrap.Td>Date Published</Wrap.Td>
              <Wrap.Td>Status </Wrap.Td>
              <Wrap.Td>View</Wrap.Td>
              <Wrap.Td>Action</Wrap.Td>
            </Wrap.Tr>
          </Wrap.Thead>
          <Wrap.Tbody>
            {meHousesList?.length === 0 ? (
              <tr style={{ margin: "auto" }}>
                <td>
                  <NoData />
                </td>
              </tr>
            ) : (
              meHousesList.map((item) => (
                <Wrap.Tr key={item?.id}>
                  <Wrap.Td>
                    <Wrap.ImgBtn>FEATURED</Wrap.ImgBtn>
                    <Wrap.Img src={img} />
                    <Wrap.Details>
                      <Wrap.DetailsTitle>
                        {item?.name || "not given"}
                        <span> FOR SALE</span>
                      </Wrap.DetailsTitle>
                      <Wrap.DetailsDescrpt>
                        {item?.adrress || "adress"}, {item?.city || "city"},
                        {item?.country || "country"}
                      </Wrap.DetailsDescrpt>
                      <div className="fsale">
                        ${item?.price || "not given"}/mo
                      </div>
                      <div className="sale">
                        ${item?.salePrice || "not given"}/mo
                      </div>
                    </Wrap.Details>
                  </Wrap.Td>
                  <Wrap.Td>
                    <div className="date">{item?.published || "not given"}</div>
                  </Wrap.Td>
                  <Wrap.Td>
                    <div className="pending">Pending</div>
                  </Wrap.Td>
                  <Wrap.Td>
                    <div className="view">3032</div>
                  </Wrap.Td>
                  <Wrap.Td>
                    <Wrap.Drawer
                      closable={false}
                      placement="right"
                      onClose={onClose}
                      width={"50%"}
                      visible={visible}
                    >
                      <Edit onClose={onClose} id={item?.id} />
                    </Wrap.Drawer>
                    <Wrap.Pen onClick={showDrawer} />
                    <Popconfirm
                      title="Are you sure to delete this house?"
                      onConfirm={() => confirm(item?.id)}
                      onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Wrap.Trash />
                    </Popconfirm>
                  </Wrap.Td>
                </Wrap.Tr>
              ))
            )}
          </Wrap.Tbody>
        </Wrap.Table>

        <Wrap.Pagination>
          <Pagination
            current={page}
            total={meTotal}
            showSizeChanger={false}
            pageSize={size}
            onChange={handlePaginationChange}
          />
        </Wrap.Pagination>
      </Wrap.Body>
    </Wrap>
  );
}
